import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { Desktop, Mobile } from "./components";

export const SuccessPayment = () => {
  return <ResponsiveBlockSwitcher desktop={<Desktop />} mobile={<Mobile />} />;
};
